import { Component } from '@angular/core';

@Component({
  selector: 'app-sun-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './sun-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class SunIconComponent {}
